import output from './output-writer';

const asyncErrorWrapper =
  <T>(actionHandler: (options: T) => Promise<void>) =>
  async (options: T) => {
    try {
      await actionHandler(options);
    } catch (error) {
      output.error(error instanceof Error ? error.message : String(error));
      process.exit(1);
    }
  };

export default asyncErrorWrapper;
